export default __webpack_public_path__ + "static/media/theme-editor.1a638080.svg";